import { CreateWorkflowNode, LLMPromptConfiguration } from 'api/model';
import { NodeFormProps } from 'api/workflows-steps/formSchema';
import LLMCommonForm from './LLMCommonForm';
import { handleEvaluationChange, prepareEvaluationInitialValues } from './evaluationSettings';

type LLMPromptFormProps = NodeFormProps & {
  validate?: boolean;
};

const prepareInitialValues = (initialValues: CreateWorkflowNode | undefined): CreateWorkflowNode => {
  if (!initialValues) {
    return {} as CreateWorkflowNode;
  }

  const configuration = initialValues.configuration as LLMPromptConfiguration | undefined;
  if (!configuration) {
    return initialValues;
  }

  const newConfiguration: LLMPromptConfiguration = {
    ...configuration,
    expand_multimodal_settings: Boolean(
      configuration.multimodal_file_content_column ||
        configuration.multimodal_file_type_column ||
        configuration.multimodal_file_type,
    ),
  };

  prepareEvaluationInitialValues(newConfiguration);

  return { ...initialValues, configuration: newConfiguration };
};

const LLMPromptForm = (props: LLMPromptFormProps) => {
  const initialValues = prepareInitialValues(props.initialValues);

  return <LLMCommonForm {...props} initialValues={initialValues} onConfigurationChange={handleEvaluationChange} />;
};

export default LLMPromptForm;
